import { useQuery } from '@apollo/client'

import { GetUpsellRequestsByModuleDocument } from 'generated/resources/graphql'
import { AvailableModules } from 'generated/featureDefinitions'

const isToday = (dateString: string): boolean => {
  const date = new Date(dateString)
  const today = new Date()
  return (
    date.getUTCFullYear() === today.getUTCFullYear() &&
    date.getUTCMonth() === today.getUTCMonth() &&
    date.getUTCDate() === today.getUTCDate()
  )
}

interface UseHasRequestedTodayResult {
  hasRequestedToday: boolean
  loading: boolean
}

export const useHasRequestedToday = (
  moduleRequested?: AvailableModules
): UseHasRequestedTodayResult => {
  const { data, loading } = useQuery(GetUpsellRequestsByModuleDocument, {
    variables: { moduleRequested },
    skip: !moduleRequested,
    fetchPolicy: 'cache-and-network',
  })

  const requests = data?.upsell?.upsellRequests ?? []
  const hasRequestedToday = requests.some(
    (request) => request.createdAt && isToday(request.createdAt)
  )

  return { hasRequestedToday, loading }
}
